import React, { useState, useEffect, useContext } from "react";
import "../../forms-style.scss";
import { downloadDocument, goToDashboardAfterDownload } from "../../Util/DownloadHelper";
import { readCookie, getPortalCD } from "../../Util/helper";
import UserServiceApi from "../../Services/UserService";
import PaymentServiceAPI from "../../Services/PaymentServiceApi";
import { useNavigate } from "react-router-dom";
import { APP_NAVIGATION } from "../../Util/Constants";
import PathHelper from "../../Util/PathHelper";
import { getSsoLegalSimpliEndPoint } from "../../Services/base-url/api-constants";
import BillingDataContext from "../../Contexts/Billing.Context";
import { formatDate } from "../../Services/MasterData";
import OrchestrationService from "../../Services/OrchestrationService";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import { trackLSEvents } from "../../Util/tracking-events";
import { v4 as UUID4 } from "uuid";
type Props = {};

const ConfirmationPage = (props: Props) => {
  const { state } = useContext(BillingDataContext);
  const { orderId, skulabel, unitPrice, recurringPrice, currencySymbol, scheduleTypeCD } = state;
  const [accountId, setAccountId] = useState("");
  const [dynamicTitle, setDynamicTitle] = useState("");
  const [recurringPriceFormat, setRecurringPrice] = useState("");
  const [unitPriceFormat, setUnitPrice] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const queryParams = new URLSearchParams(window.location.search);
  const [skuGuidDetails, setSkuGuidDetails] = useState<any>();
  const [showLoader, setShowLoader] = useState("d-none");

  let userguid = readCookie("userguid");
  const onDownloadClick = () => {
    const userguid = readCookie("userguid");
    const docid = readCookie("docid");
    if (userguid && docid) {
      setShowLoader("d-block");
      downloadDocument(docid, "1", "", "", false, false, setShowLoader);
    }
  };
  const goToDashboardAndDownload = () => {
    const userguid = readCookie("userguid");
    const docid = readCookie("docid");
    if (userguid && docid) {
      setShowLoader("d-block");
      downloadDocument(docid, "1", "", "", false, true, setShowLoader);
    } else {
      goToDashboardAfterDownload(true);
    }
  };

  useEffect(() => {
    trackLSEvents("confirmationView", {});

    if (!!readCookie("jwtToken")) {
      UserServiceApi.getUserByUserGuid(userguid)
        .then((userResponse: any) => {
          if (userResponse) {
            setAccountId(userResponse.accountId);
            setOrderDate(formatDate(userResponse.creationDate));
            setRecurringPrice(currencySymbol + parseFloat(recurringPrice.toString()).toFixed(2));
            setUnitPrice(currencySymbol + parseFloat(unitPrice.toString()).toFixed(2));
            OrchestrationService.setConfirmationinCB(userguid);
          }
        })
        .catch((error: any) => {});
    }
  }, []);
  return (
    <>
      <ReactLoader loaderProps={{ showloader: showLoader }} />
      <section className="successful-section">
        <div className="container">
          <div className="images">
            <img src={process.env.PUBLIC_URL + "/static/images/check.svg"} alt="check" />
            <h1>Payment Successful</h1>
            <p>
              Thank you for subscribing. <br /> A receipt has been sent to the email address provided
            </p>
          </div>
        </div>
      </section>
      <section className="details-page-section">
        <div className="container">
          <div className="details-wrapper">
            <div className="row">
              <div className="col-lg-6 mb-2">
                <div className="left left-section">
                  <h5>Details</h5>
                  <ul>
                    <li>
                      Account ID :<span>{accountId}</span>
                    </li>
                    <li>
                      Amount :<span>{scheduleTypeCD === "YEAR" ? recurringPriceFormat : unitPriceFormat}</span>
                    </li>
                    <li>
                      Date :<span>{orderDate}</span>
                    </li>
                    <li>
                      Order ID :<span>{orderId}</span>
                    </li>
                  </ul>
                  <a onClick={goToDashboardAndDownload} className="btn btn-sm theme-btn-outline-primary setCulture">
                    Go to Dashboard
                  </a>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="right-content">
                  <div className="display:block">
                    <h5>What&apos;s Next</h5>
                    <div>
                      <p>
                        The file that you were working on is ready for download. Please click below to begin download.
                      </p>
                      {!!readCookie("docid") && (
                        <>
                          {" "}
                          <div className="fbn bounce-effect">
                            <a id="downloadLink" className="btn btn-lg theme-btn-primary" onClick={onDownloadClick}>
                              Download Now
                            </a>
                          </div>
                        </>
                      )}
                    </div>
                    <p>
                      View all your documents or upload new documents to edit, convert, annotate, sign or share. Also,
                      add users or manage your subscription from the dashboard.
                    </p>
                    <div className="brands-logo new-logo">
                      <div className="row">
                        <ul>
                          <li>
                            <img src={process.env.PUBLIC_URL + "/static/images/PDFSimpli-logo.svg"} alt="PDFSimpli" />
                          </li>
                          <li>
                            <img src={process.env.PUBLIC_URL + "/static/images/worksimpli-logo.svg"} alt="WORKSimpli" />
                          </li>
                          <li>
                            <img src={process.env.PUBLIC_URL + "/static/images/signsimpli-logo.svg"} alt="SIGNSimpli" />
                          </li>
                          <li>
                            <img src={process.env.PUBLIC_URL + "/static/images/docusimpli-logo.svg"} alt="DOCUSimpli" />
                          </li>

                          <li>
                            <img src={process.env.PUBLIC_URL + "/static/images/resumebuild.svg"} alt="RESUMEbuild" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="bottom">
                  <p className="disclaimer">
                    For payment, technical or product related questions please contact
                    <a href="mailto:support@legalsimpli.com" style={{ color: "#007bff" }}>
                      {" "}
                      support@legalsimpli.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="industries-categories-feature">
        <div className="container py-2">
          <div className="header">
            {/* <h2>As an added bonus when you sign up for any of the above</h2>
            <p className="sub-headline">
              LegalSimpli plans you will have full access to ALL the WorkSimpli suite of products.
            </p> */}
            <h2>As an added bonus </h2>
            <p className="sub-headline">You now have full access to ALL the WorkSimpli suite of products</p>
          </div>
          <div className="row row-eq-height our-brands text-center">
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="icon pb-3">
                <img src={process.env.PUBLIC_URL + "/static/images/PDFSimpli-logo.svg"} alt="PDFSimpli" />
              </div>
              <p>
                <b>PDFSimpli</b> helps you modify, edit, store, convert, and add e-signatures to almost any document,
                with multiple users and unlimited storage. All done from just one web-based, simple platform that will
                boost your productivity!
              </p>
            </div>
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="icon pb-3">
                <img src={process.env.PUBLIC_URL + "/static/images/signsimpli-logo.svg"} alt="SIGNSimpli" />
              </div>
              <p>
                <b>SignSimpli</b> is the easiest way to add electronic signatures to documents using hundreds of
                templates of the most common legal documents, including sales contracts, NDAs, sales agreements,
                onboarding paperwork, mortgage, escrows, and financial agreements.
              </p>
            </div>
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="icon pb-3">
                <img src={process.env.PUBLIC_URL + "/static/images/resumebuild.svg"} alt="RESUMEbuild" />
              </div>
              <p>
                <b>ResumeBuild</b> allows you to create a perfect resume and cover letter with professional,
                out-of-the-box templates and step-by-step instructions, instantly generated by the most advanced resume
                builder technology available. Available in English, French, Spanish and Italian.
              </p>
            </div>
            <div className="col-md-6 col-lg-6 mb-4">
              <div className="icon pb-3">
                <img src={process.env.PUBLIC_URL + "/static/images/legalsimpli-logo.svg"} alt="LEGALSimpli" />
              </div>
              <p>
                <b>LegalSimpli</b> it’s the most affordable and effortless way of creating legal documents without
                hiring an attorney just by choosing from our library of hundreds of legal documents and common business
                forms for individuals and businesses.
              </p>
            </div>
            <div className="col-sm-6 col-md-12 col-lg-6 mb-4">
              <div className="icon pb-3">
                <img src={process.env.PUBLIC_URL + "/static/images/docusimpli-logo.svg"} alt="DOCUSimpli" />
                <span className="d-block mt-1" style={{ color: "#f9593a", fontSize: "13px", fontWeight: "bold" }}>
                  COMING SOON
                </span>
              </div>
              <p>
                <b>DocuSimpli</b> allows you to upload, edit, capture, and extract data or images effortlessly from just
                one place and then download directly to the format of your preference in just minutes!
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ConfirmationPage;
